import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { ProyectoService } from "./ProyectoService";

/** Baja de proyectos; la saca del listado en memoria. */
export class ProyectoDeleteService extends ServiceDeleteBase {
  protected readonly cache = ProyectoService.instance;

  /** gRPC-Web (`EliminarProyecto`): baja lógica, idempotente. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(ProyectosPlataformaService).eliminarProyecto({ id }));
  }
}
